import {
  CardContainer,
  Divider,
  InfoContainer,
  TestDriveTextContainer,
} from "./../../components/car-card/styles";
import { css } from "styled-components";
import { VerticalDivider } from "../../components/car-category/styles";
import { HeaderContainer } from "../containers";
import {
  Abbr,
  CustomLink,
  FieldContainer,
  FieldErrorText,
  SubmitButtonTestDrive,
  TestDriveBackButton,
} from "../../forms/test-drive/personalia/styles";
import { SubmitButtonContactUs } from "../../forms/contact/styles";
import {
  Dropdown,
  PickOtherDealerButton,
} from "../../components/dealer-lookup/styles";
import { LoadingSpinnerStyle } from "../../components/loading-spinner/styles";
import { ExploreMoreLinkOpel } from "../../components/receipt/styles";
import { SubmitButtonNewsLetter } from "../../forms/newsletter/styles";

export const OpelStyle = css`
  --black: #000000;
  --electric-blue: #00a3e0;
  --grey-light: #f7f7f7;
  --white: #ffffff;
  --kryptonite: #bfdd0b;
  --electric-blue-light: #4cc9f9;
  --grey-light-deep: #ececee;
  --grey-medium: #adaeb2;
  --grey-dark: #787b80;
  --error: #cc0000;
  --valid: #3a8000;
  --gray: #f3f3f3;
  --yellow: #f7ff14;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6  {
    font-family: "OpelBold";
  }

  .title-h1,
  .title-h2 {
    text-transform: uppercase;
  }
  .title-h1-bestillPrøvekjøring {
    margin-top: var(--sp80);
    font-family: "OpelLight";
  }
  .title-h1-prøvekjøring {
    text-transform: uppercase;
  }
  .title-h2-light {
    font-family: "OpelLight";
    margin-bottom: var(--sp64);
  }
  .title-h1-OpelLight {
    font-family: "OpelLight";
    text-transform: uppercase;
    word-break: break-word;
  }
  .title-h1-OpelBold {
    font-family: "Opel";
    margin-top: 0;
    text-transform: uppercase;
    word-break: break-word;
  }
  @media (max-width: 768px) {
    .title-h1-bestillPrøvekjøring,
    .title-h1-prøvekjøring {
      margin-left: var(--sp24);
    }
  }

  ${HeaderContainer} {
    background: var(--white);
    color: var(--black);
    a {
      color: var(--black);
      text-decoration: none;
    }
    -webkit-box-shadow: 0px 3px 6px -3px rgba(0, 0, 0, 0.52);
    box-shadow: 0px 3px 6px -3px rgba(0, 0, 0, 0.52);
  }

  ${PickOtherDealerButton} {
    text-decoration-color: var(--black);
    text-decoration-thickness: 3px;
    text-underline-offset: 5px;
  }

  ${CardContainer} {
    background: var(--gray);
  }

  ${TestDriveTextContainer} {
    background: var(--yellow);
    color: var(--black);
    text-transform: uppercase;
  }

  ${Divider} {
    color: var(--black);
  }

  ${VerticalDivider} {
    color: var(--grey-light);
  }

  ${SubmitButtonTestDrive} {
    background: var(--black);
    color: var(--white);
    font-family: "Opel";
    text-transform: uppercase;
    font-size: 16px;
  }

  ${SubmitButtonContactUs} {
    background: var(--black);
    color: var(--white);
    font-family: "Opel";
    text-transform: uppercase;
    font-size: 16px;
  }
  ${SubmitButtonNewsLetter} {
    background: var(--black);
    color: var(--white);
    font-family: "Opel";
    text-transform: uppercase;
    font-size: 16px;
  }

  ${FieldContainer} {
    input,
    textarea,
    input[type="number"],
    select {
      font-size: 16px;
      border-radius: 0;
      border: 2px solid var(--grey-medium);
    }
  }

  ${FieldErrorText} {
    color: var(--error);
  }

  ${TestDriveBackButton} {
    text-decoration-color: var(--black);
    text-underline-offset: 5px;
    text-decoration-thickness: 3px;
    background: var(---grey-light);
  }

  ${Dropdown} {
    background-image: url("data:image/svg+xml;utf8,<svg fill='%2300a3e0' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    border: 2px solid var(--grey-medium);
  }

  ${Abbr} {
    color: var(--error);
  }

  ${InfoContainer} {
    p {
      color: var(--grey-dark);
    }
  }

  ${LoadingSpinnerStyle} {
    .loader,
    .loader:after,
    .loader:before {
      background: var(--yellow);
    }
    .loader {
      color: var(--yellow);
    }
  }

  ${ExploreMoreLinkOpel} {
    border: 2px solid var(--black);
    color: var(--white);
    font-family: "OpelBold";
    background: var(--black);
    text-transform: uppercase;
  }

  ${CustomLink} {
    text-underline-offset: 5px;
    text-decoration-color: var(--electric-blue-light);
    text-decoration-thickness: 3px;
  }
`;
